module.exports = __webpack_public_path__ + "static/media/turta-icon.3b7743a0.svg";